import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { ChartComponent } from 'ng-apexcharts';

@Component({
  selector: 'app-company-metric-value-visualization-dialog',
  templateUrl: './company-metric-value-visualization-dialog.component.html',
  styleUrls: ['./company-metric-value-visualization-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CdkScrollable, MatButtonModule, MatDialogActions, MatDialogContent, MatDialogTitle, ChartComponent],
})
export class CompanyMetricValueVisualizationDialogComponent {
  private readonly dialog_ref = inject(MatDialogRef<CompanyMetricValueVisualizationDialogComponent>);
  readonly data = inject<CompanyMetricValueVisualizationDialogData>(MAT_DIALOG_DATA);

  close(): void {
    this.dialog_ref.close();
  }
}

export interface CompanyMetricValueVisualizationDialogData {
  title: string;
  chart: Record<string, unknown>;
}
